import apiFetch from '../apiFetch'

export default function (token, suppliedId) {
  return apiFetch({ endPoint: `SuppliedType/${suppliedId}`, method: 'GET', body: null, token: token })
}
